"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorMessages = exports.ErrorMessageKeys = void 0;
var ErrorMessageKeys;
(function (ErrorMessageKeys) {
    ErrorMessageKeys[ErrorMessageKeys["REQUIRED_PROPS_MISSING"] = 0] = "REQUIRED_PROPS_MISSING";
})(ErrorMessageKeys = exports.ErrorMessageKeys || (exports.ErrorMessageKeys = {}));
exports.errorMessages = {
    [ErrorMessageKeys.REQUIRED_PROPS_MISSING]: 'is missing required props.',
};
